<template>
    <div>
        <b-modal
            id="m-scan-box-pei"
            title="Scan Box"
            hide-footer
            @hidden="onHidden"
        >
            <b-form @submit.prevent="submitScan">
                <b-row
                    class="align-items-center d-flex justify-content-center "
                >
                    <b-col md="8">
                        <b-form-group label="Kode Box / No. Resi" label-for="scan-box">
                            <b-form-input
                                id="scan-box"
                                v-model="searchKey"
                                required
                                placeholder="Masukkan Kode Box / No. Resi..."
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="4" class="d-flex align-items-end">
                        <b-form-group
                            label="Kamera Scan"
                            label-for="scan-box"
                            class="w-100"
                        >
                            <b-button
                                size="md"
                                variant="info"
                                @click="toggleCamera"
                                :disabled="isSubmitting"
                                class="text-white w-100"
                            >
                                {{ scanning ? "Stop Camera" : "Start Camera" }}
                            </b-button>
                        </b-form-group>
                    </b-col>
                </b-row>

                <div v-if="scanning" class="mt-2">
                    <video
                        ref="video"
                        playsinline
                        muted
                        :style="{
                            width: '100%',
                            height: '320px',
                            objectFit: 'cover',
                            background: '#000'
                        }"
                    ></video>
                    <canvas ref="canvas" style="display:none;"></canvas>
                    <div class="small text-center text-muted mt-1">
                        Arahkan kamera ke QR/Barcode.
                    </div>
                </div>

                <div class="d-flex justify-content-end mt-3">
                    <b-button variant="secondary" @click="closeModal"
                        >Batal</b-button
                    >
                    <b-button
                        class="ml-2"
                        type="submit"
                        variant="success"
                        :disabled="isSubmitting"
                    >
                        {{ isSubmitting ? "Memproses..." : "Submit" }}
                    </b-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import jsQR from "jsqr";

export default {
    name: "ModalScanBoxPEI",
    data() {
        return {
            searchKey: "",
            isSubmitting: false,
            scanning: false,
            stream: null,
            scanTimer: null
        };
    },
    methods: {
        onHidden() {
            this.stopCamera();
            this.clearInput();
        },

        clearInput() {
            this.searchKey = "";
            this.isSubmitting = false;
        },

        closeModal() {
            this.$bvModal.hide("m-scan-box-pei");
        },

        async submitScan() {
            await this.doSubmit(this.searchKey);
        },

        async doSubmit(key) {
            if (!key) return;
            if (this.isSubmitting) return;
            this.isSubmitting = true;
            try {
                const payload = { key: key };
                await this.$axios.post("/gold-deliveries/received", payload);
                this.$helper.toastSuccess(this, "Penerimaan berhasil");
                this.$bvModal.hide("m-scan-box-pei");
                this.$emit("refresh-items");
                this.$emit("scanned");
            } catch (err) {
                this.$helper.parseError(this, err);
            } finally {
                this.isSubmitting = false;
                this.stopCamera();
            }
        },

        toggleCamera() {
            if (this.scanning) {
                this.stopCamera();
            } else {
                this.startCamera();
            }
        },

        async waitForRef(refName, timeout = 2000, interval = 50) {
            const start = Date.now();
            while (Date.now() - start < timeout) {
                await this.$nextTick();
                const el = this.$refs[refName];
                if (el) return el;
                await new Promise(r => setTimeout(r, interval));
            }
            return null;
        },

        async startCamera() {
            if (this.scanning) return;
            if (
                !navigator.mediaDevices ||
                !navigator.mediaDevices.getUserMedia
            ) {
                this.$helper.toastError(
                    this,
                    "Browser tidak mendukung getUserMedia"
                );
                return;
            }
            let stream = null;
            try {
                const constraints = {
                    video: { facingMode: { ideal: "environment" } }
                };
                stream = await navigator.mediaDevices.getUserMedia(constraints);
                this.scanning = true;
                this.stream = stream;

                const video = await this.waitForRef("video", 3000);
                if (!video) {
                    if (stream) stream.getTracks().forEach(t => t.stop());
                    this.stream = null;
                    this.scanning = false;
                    return;
                }

                try {
                    video.srcObject = stream;
                } catch (e) {
                    video.src = window.URL.createObjectURL(stream);
                }

                await new Promise(resolve => {
                    const onCanPlay = () => {
                        video.removeEventListener("canplay", onCanPlay);
                        resolve();
                    };
                    video.addEventListener("canplay", onCanPlay);
                    const p = video.play();
                    if (p && p.catch) p.catch(() => {});
                    setTimeout(resolve, 1000);
                });

                this.scanTimer = setInterval(this.scanFrame, 400);
            } catch (err) {
                this.$helper.toastError(
                    this,
                    "Gagal mengakses kamera: " + (err.message || err)
                );
                this.scanning = false;
                if (stream) {
                    stream.getTracks().forEach(t => t.stop());
                    this.stream = null;
                }
            }
        },

        stopCamera() {
            if (this.scanTimer) {
                clearInterval(this.scanTimer);
                this.scanTimer = null;
            }
            if (this.stream) {
                this.stream.getTracks().forEach(t => t.stop());
                this.stream = null;
            }
            const video = this.$refs.video;
            if (video) {
                if (video.srcObject) video.srcObject = null;
                if (video.src && video.src.startsWith("blob:")) {
                    URL.revokeObjectURL(video.src);
                    video.src = "";
                }
                video.pause();
            }
            this.scanning = false;
        },

        scanFrame() {
            const video = this.$refs.video;
            const canvas = this.$refs.canvas;
            if (!video || video.readyState !== video.HAVE_ENOUGH_DATA) return;

            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            const imageData = ctx.getImageData(
                0,
                0,
                canvas.width,
                canvas.height
            );

            const code = jsQR(
                imageData.data,
                imageData.width,
                imageData.height
            );
            if (code && code.data) {
                this.searchKey = code.data.trim();
                this.stopCamera();

                setTimeout(() => {
                    this.doSubmit(this.searchKey);
                }, 200);
            }
        }
    },
    beforeDestroy() {
        this.stopCamera();
    }
};
</script>
